import React, { useMemo } from 'react';
import BuyerCard from 'routes/profile/models/BuyerCard';
import ProfileTab from 'components/profile/ProfileTab';
import ProfileTabList from 'components/profile/ProfileTabList';
import ReceiptDeliveryOptions from './ReceiptDeliveryOptions';
import {
  CardPreference,
  Product as CardPreferenceProduct,
} from 'routes/profile/models/CardPreference';

type ReceiptCardTabsProps = {
  paymentCards?: BuyerCard[];
  primaryCardId?: string;
  selectedPaymentCardId?: string;
  onCardSelected: (cardsApiId: string) => void;
  cardPreferences: CardPreference[];
  isRetrievePrefsLoading: boolean;
};

const ReceiptCardTabs: React.FC<ReceiptCardTabsProps> = ({
  paymentCards,
  primaryCardId,
  selectedPaymentCardId,
  onCardSelected,
  cardPreferences,
  isRetrievePrefsLoading,
}) => {
  const orderedPaymentCards = useMemo(() => {
    if (!paymentCards) {
      return [];
    }

    const primaryCardIdx = paymentCards.findIndex(
      (card) => card.cardsApiId === primaryCardId
    );
    if (primaryCardIdx === -1) {
      return paymentCards;
    }

    return [
      paymentCards[primaryCardIdx],
      ...paymentCards.slice(0, primaryCardIdx),
      ...paymentCards.slice(primaryCardIdx + 1),
    ];
  }, [paymentCards, primaryCardId]);

  const selectedCard = orderedPaymentCards.find(
    (card) => card.cardsApiId === selectedPaymentCardId
  );

  return (
    <div>
      <ProfileTabList>
        {orderedPaymentCards.map((card) => (
          <ProfileTab
            key={card.cardsApiId}
            id={card.cardsApiId}
            tabId={`receipt-card-tab-${card.cardsApiId}`}
            controls={`receipt-card-panel-${card.cardsApiId}`}
            selected={selectedPaymentCardId === card.cardsApiId}
            onSelected={onCardSelected}
          >
            <span data-testid={'card-display-name'}>{card.displayName}</span>
          </ProfileTab>
        ))}
      </ProfileTabList>
      {selectedCard && (
        <div
          role="tabpanel"
          id={`receipt-card-panel-${selectedCard.cardsApiId}`}
          aria-labelledby={`receipt-card-tab-${selectedCard.cardsApiId}`}
        >
          <ReceiptDeliveryOptions
            preferenceCardId={selectedCard.preferenceCardId}
            cardPreferences={cardPreferences.filter(
              (pref) => pref.product === CardPreferenceProduct.Receipt
            )}
            isRetrievePrefsLoading={isRetrievePrefsLoading}
          />
        </div>
      )}
    </div>
  );
};

export default ReceiptCardTabs;
